import React, {
  MutableRefObject,
  useEffect,
  useLayoutEffect,
  useMemo,
  useState,
} from 'react'
import { AllGalleriesViewProps } from './AllGalleries.types'
import Styles from './AllGalleries.module.scss'
import Text from '@onepercentio/one-ui/components/Text'
import { FigmaTypo } from 'containers/OneUIProvider/OneUIProvider'
import { tO } from 'translate/i18n'
import Section from 'openspace/components/Section'
import {
  useContainerPagination,
  useLocalPagination,
} from '@onepercentio/one-ui/hooks/usePagination'
import GalleryCard, {
  useGalleryBaseWidth,
} from 'openspace/components/GalleryCard'
import Container from 'openspace/components/Container'
import useElementFit from '@onepercentio/one-ui/hooks/useElementFit'
import useMergeRefs from '@onepercentio/one-ui/hooks/useMergeRefs'
import TogglableTags from 'openspace/components/TogglableTags'
import SectionLoader from 'openspace/components/SectionLoader/SectionLoader'
import GalleryCardVariables from 'openspace/components/GalleryCard/GalleryCard.module.scss'

/**
 * Show all the galleries (Tenant oken: OrderableList removed)
 **/
export default function AllGalleriesView({
  galleries,
  filter,
}: AllGalleriesViewProps) {
  const baseWidth = useGalleryBaseWidth(galleries?.[0])
  const { anItemMore, ref } = useElementFit(baseWidth)
  const {
    getNextPage,
    getPage,
    items: galleriesPaginated,
  } = useLocalPagination(filter.filteredGalleries || [])
  const { scrollableRef } = useContainerPagination(getNextPage, anItemMore!)
  useEffect(() => {
    if (anItemMore) getPage(0, anItemMore!)
  }, [filter.filteredGalleries, anItemMore])
  useLayoutEffect(() => {
    ; (scrollableRef as MutableRefObject<HTMLDivElement>).current =
      mainRef.current!.parentElement!.parentElement! as HTMLDivElement
  })
  const mainRef = useMergeRefs(ref)
  const galleriesBaseWidth =
    galleries && galleries.length > 0 && galleries[0].type === 'cvm88'
      ? Number(GalleryCardVariables.baseWidthcvm88) + 16
      : Number(GalleryCardVariables.baseWidthdefault) + 26

  return (
    <>
      <Container>
        <Text className={Styles.title} type={FigmaTypo.H1}>
          {tO('allGalleries.title')}
        </Text>
      </Container>
      <Container>
        <TogglableTags
          tags={filter.categories.map((c) => ({
            active: c === filter.selectedCategory,
            label: c,
            id: c,
          }))}
          onClick={(c) => filter.onSelectCategory(c)}
        />
      </Container>
      <Container className={Styles.galleriesList} ref={mainRef}>
        {galleries && galleriesPaginated ? (
          <div className={Styles.orderableGalleries}>
            {galleriesPaginated.map((a) => <div style={{ maxWidth: galleriesBaseWidth}}>
              <GalleryCard
                key={a.id}
                shouldExpandOnMount={false}
                gallery={a}
                mode='default'
              />
            </div>)}
          </div>
        ) : (
          <SectionLoader />
        )}
      </Container>
    </>
  )
}

